/* eslint-disable max-len */
import { Component } from "preact";
import style from "./style";
import {
  Map,
  TileLayer,
  Popup,
  Circle,
  FeatureGroup,
  GeoJSON,
} from "react-leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import Leaflet from "leaflet";
import PreLoader from "../../preLoader";
import "leaflet/dist/leaflet.css";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import NoDataTemplate from "../../no-data-template";
import Api from "../../../lib/api";
import { polygons } from "../polygons";

let DefaultIcon = Leaflet.icon({
  iconUrl: icon,
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  iconShadow,
  popupAnchor: [2, -20],
});

Leaflet.Marker.prototype.options.icon = DefaultIcon;

const colorOptions = {
  country: "#6a8ed2",
  region: "#ffa500",
};

const getPolygon = (code) => {
  for (let i = 0; i < polygons.length; i++) {
    if (polygons[i].code === code) {
      return polygons[i];
    }
  }
  return null;
};

export default class MapComponent extends Component {
  render() {
    if (this.props.mapData.loading) return <PreLoader />;
    if (
      !this.props.mapData ||
      !this.props.mapData.data ||
      !this.props.mapData.data.length
    )
      return <NoDataTemplate />;
    return (
      <Map
        attributionControl={false}
        className={style.mainWrapper}
        center={[33, 35]}
        minZoom={5}
        zoom={6}
        maxZoom={7}
        scrollWheelZoom={false}
      >
        <TileLayer
          url={
            "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
          }
        />
        {this.props.mapData.data.map((item) => (
          <FeatureGroup>
            {getPolygon(item.code) ? (
              <GeoJSON
                data={getPolygon(item.code).coordinates}
                color={getPolygon(item.code).color}
              />
            ) : (
              <Circle
                center={[item.lat, item.lon]}
                radius={
                  150 * item.activities.length > 10000
                    ? 150 * item.activities.length
                    : 10000
                }
                color={colorOptions.region}
              />
            )}
            <Popup className={style.popupWrapper}>
              <div>
                <b>
                  <a href={`/profile/${item.name}/recipientprofile`}>
                    {item.name}
                  </a>
                </b>
                <div className={style.popupContentWrapper}>
                  {item.activities.map((activity) => (
                    <div key={activity.identifier}>
                      <a
                        href={`/projects/${activity.identifier}`}
                        alt={activity.title}
                      >
                        {activity.title}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </Popup>
          </FeatureGroup>
        ))}
      </Map>
    );
  }
}



// WEBPACK FOOTER //
// ./components/activities-map/component/index.js